import React from 'react';
import { NamePath } from 'antd/lib/form/interface';
import { I18n } from '@aws-amplify/core';
import { Col, Input } from 'antd';

import { CustomFormItem } from './styles';

const { TextArea } = Input;

interface SpecificationsProps {
	fieldName: NamePath;
}

export const Specifications: React.FC<SpecificationsProps> = ({ fieldName }) => {
	return (
		<Col xs={24} sm={12} lg={24}>
			<CustomFormItem name={fieldName} label={I18n.get('Specifications')} labelCol={{ span: 24 }}>
				<TextArea rows={4} maxLength={500} showCount />
			</CustomFormItem>
		</Col>
	);
};
